import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import styles from "./Login.module.css";

import { Button, Checkbox, Form, Input, Modal } from "antd";
import { AppContext } from "../App.context";
import axios from "axios";
import {
  checkAuth,
  checkEmpty,
  getToken,
  getUserMe,
  initApi,
  isAdmin,
  pathRoutes,
  setToken,
} from "../service/util.service";
import {
  useLocation,
  useNavigate,
  useNavigation,
  useSearchParams,
} from "react-router-dom";
import LoadingCenterSpinSmall from "../main/LoadingCenterSpinSmall";
import { WarningOutlined } from "@ant-design/icons";

function Init(props) {
  const [texts, setTexts] = useState([]);

  const initLoad = async () => {
    try {
      let textsuse = texts;
      if (textsuse.length == 0) {
        let resInit = await initApi();
        // setText(JSON.stringify(resInit));
        textsuse.push(JSON.stringify(resInit));
        setTexts(Object.assign([], textsuse));
      }
    } catch (e) {}
  };

  useEffect(() => {
    // initLoad();
  }, []);

  useEffect(() => {
    initLoad();
    /*
    Query logic
    */
    console.log("i fire once");
  }, []);

  return (
    <div>
      {texts.map((text) => {
        return <div>{text}</div>;
      })}
    </div>
  );
}
export default Init;
